import React from "react";
import Eyebrow from "../../elements/Eyebrow";
import Panel from "../../elements/Panel";
import getClassNameFactory from "../../utilities/classNames";

var Callout = function Callout(_ref) {
  var eyebrowText = _ref.eyebrowText,
      children = _ref.children,
      asset = _ref.asset,
      assetWidth = _ref.assetWidth;
  var getClassName = getClassNameFactory(Callout.displayName);
  var assetEl;

  if (asset) {
    assetEl = /*#__PURE__*/React.createElement("div", {
      className: getClassName({
        descendantName: "asset"
      })
    }, asset);
  }

  return /*#__PURE__*/React.createElement(Panel, {
    className: getClassName({
      componentName: "CalloutOverride"
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      modifiers: assetWidth
    })
  }, assetEl, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "body"
    })
  }, eyebrowText && eyebrowText.length > 0 && /*#__PURE__*/React.createElement(Eyebrow, {
    text: eyebrowText
  }), children)));
};

Callout.displayName = "Callout";
Callout.defaultProps = {
  assetWidth: "square"
};
export default Callout;